import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authCallback } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = match[1];
    (async () => {
      try {
        const res = await authCallback(sessionId);
        setUser(res.user);
        // Clear the hash before navigating.
        window.history.replaceState(null, "", window.location.pathname);
        // First-time users — bounce to /onboarding so they pick a wallet
        // handle before doing anything else. Returning users go to
        // /welcome, which is tier-aware and routes architects to /console
        // and free operators to the public truth feed.
        const dest = res.user?.username_set ? "/welcome" : "/onboarding";
        navigate(dest, { replace: true, state: { user: res.user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] text-zinc-100">
      <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.35em] text-emerald-400">
        <Loader2 className="h-4 w-4 animate-spin" />
        Docking handshake…
      </div>
    </div>
  );
}
